import { render } from "./FormDonation.vue?vue&type=template&id=2f616628&ts=true"
import script from "./FormDonation.vue?vue&type=script&lang=ts"
export * from "./FormDonation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__